import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import initRoutes from './router/routes'
import socket from './utils/socket'
import EventBus from './utils/eventbus';

import 'boxicons'
import './assets/styles/index.scss';

import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import ElementUI from 'element-ui';
import './assets/styles/vendor/element-variables.scss';
import locale from 'element-ui/lib/locale/lang/en';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import SvgIcon from 'vue-svgicon';
import './assets/icons';
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

import PortalVue from 'portal-vue'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.use(PortalVue)

Vue.component('apexchart', VueApexCharts)

Vue.use(LottieAnimation);
Vue.use(PerfectScrollbar)

Vue.use(ElementUI, { locale });
Vue.use(Vuesax);
Vue.use(SvgIcon, {
  tagName: 'svgicon'
})

initRoutes()

const socketConnection = socket();

Vue.config.errorHandler = function (err, vm, info) {
  console.log('Custom vue error handler: ', err, vm.name, info);
};
Vue.config.warnHandler = function (err, vm, info) {
  console.log('Custom vue warn handler: ', err, vm.name, info);
};

let handleOutsideClick
Vue.directive('closable', {
  bind (el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      if (exclude.length > 0) {
        exclude.forEach(refName => {
          if (!clickedOnExcludedEl) {
            const excludedEl = vnode.context.$refs[refName]
            clickedOnExcludedEl = excludedEl.contains(e.target)
          }
        })
      }

      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind () {
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

Vue.config.productionTip = false
Vue.prototype.$socket = socketConnection;
Vue.prototype.$eventBus = EventBus;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
